import * as React from "react"
import { AxiosResponse } from "axios"
import { Provider, connect } from "react-redux"

import { echo } from "app/components/websocketeer";
import trans from "trans"
import store from "store";

import { isJson } from "app/helpers/other";
import { createToast } from "actions";
import toastFactory from "app/helpers/toast_factory";

import {
    updateInputValue as change,
} from "app/reducers/form";

import {
    setValidationByUser as apiSetMistakeByUser,
    setQualityByUser as apiSetQualityByUser,
    setWatermarkByUser as apiSetWatermarksByUser,
    publishProducts,
} from "app/helpers/api";

import {
    DiagnosticsType,
    FindSimilarType,
    ProductGeneral,
    SimilarProductsType,
} from "../types";

import { setFindSimilar, setProductsToStore } from '../reducer';
import { createProductsExport } from "app/reducers/exports";

import {
    SET_QUALITY_BY_USER,
} from "template-edit/reducers";

import { ID, ReduxList } from "app/types/app-types";
import { FiltersFormType } from "../types/filtertypes";
import { ViewTableType } from "products/containers";
import { AlternativeTemplatesLevels, Project } from "app/types/model-types";

import ProductModalWrapper from "./product-modal-wrapper";
import { ShowGroupType } from "diagnostics/diagnostics";
import ProductTableTable from "./product-table-table";
import ProductTableGrid from "./product-table-grid";
import { selectFormValues } from "app/reducers/form";
import { Option } from "@bdfx/mergado-ui-kit/lib/components/Form/Select";
import { godProjectId, isGodModeOn, projectId } from "app/helpers/api";

import {
    css,
    Paginator,
    Theme,
    Section,
    Button,
    Message,
    Checkbox,
    TextInput,
    Grid,
    GridCell,
    Icon,
    modal,
    InputGroup,
} from "@bdfx/mergado-ui-kit"

import {Badge} from "@mui/material"

export const MaxProductsPerPage = 40

interface Props {
    setFindSimilar: typeof setFindSimilar
    setProductsToStore: typeof setProductsToStore
    createProductsExport: typeof createProductsExport
    createToast: typeof createToast
    getEmptyFiltersForm: Function
    handlePaginator: Function
    handleSortBy: Function
    saveAsQuery: Function
    resetFiltersButton: Function
    filterNow: Function
    products: ReduxList<DiagnosticsType>
    filtersForm: FiltersFormType
    findSimilar: FindSimilarType
    viewTable: ViewTableType
    setViewTable: Function
    switchFiltersMode: Function
    updateProductsBouncedFast: Function
    isDirty: boolean
    filtersMode: boolean
    updateWatermarkMasksFromDb: Function
    project: Project
    alternativeTemplatesLevels: ReduxList<AlternativeTemplatesLevels>
    change: typeof change,
}

export type SimilarityWebSocketMessage = {
    project_id: ID
    product_id?: ID
    template_id?: ID
    template_ids?: string
    list_checksum: string
    n_limit: number
    threshold: number
    image_hash: string
    status?: string
    status_reason?: string
    results?: string
}

export type SimilarityFullExportWebSocketMessage = {
    export: {
        id: ID
        project_id: ID
        list_checksum: string
        total_rows: number
        exported_rows: number
        error: string
        created_at: string
        started_at: string
        finished_at: string
    },
    imageHash: string
    isSearching: boolean
}

export type SimilarityFullExportSimilarUpdateWebSocketMessage = {
    similarProducts: SimilarProductsType
}

export type SetByUser = 1 | 0 | null
export type ViewModeType = 'grid' | 'table'
export type ImgModeType = 'orig' | 'source' | 'fie' | 'other'
const imgModes: ImgModeType[] = ['orig', 'fie', 'other']   //, 'source'

interface State {
    idx: number
    viewMode: ViewModeType
    imgMode: ImgModeType
}

class ProductTable extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            idx: null,
            viewMode: 'table',
            imgMode: 'orig',
        }
    }

    componentDidMount(): void {
        const actualProjectId = isGodModeOn ? godProjectId : projectId

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.similarity.finished', (event) => this.handleProcessDone(event))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.similarity.started', (event) => this.handleProcessStarted(event))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.similarity-full-export.updated', (event) => this.handleSimilarityFullExportUpdated(event))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.similarity-full-export.similar-updated', (event) => this.handleSimilarityFullExportSimilarUpdated(event))
    }

    handleSimilarityFullExportSimilarUpdated = (message: SimilarityFullExportSimilarUpdateWebSocketMessage) => {
        this.props.setFindSimilar({
            ...this.props.findSimilar,
            similarProducts: { ...this.props.findSimilar.similarProducts, ...message.similarProducts },
            isSearching: false,
        })

        this.props.updateProductsBouncedFast()
    }

    handleSimilarityFullExportUpdated = (message: SimilarityFullExportWebSocketMessage) => {
        this.props.setFindSimilar({
            ...this.props.findSimilar,
            totalRows: message.export.total_rows,
            exportedRows: message.export.exported_rows,
            isExporting: !message.export.finished_at,
            isExportReady: !!message.export.list_checksum,
            isSearching: message.isSearching,
            csvChecksum: message.export.list_checksum,
            error: message.export.error,
        })
    }

    handleProcessStarted = (message: SimilarityWebSocketMessage) => {
        const data = this.getData()
        const productsList = data && data.data ? data.data.map(d => `${d.product_id}`) : []

        if (message.project_id === projectId && productsList.includes(`${message.product_id}`)) {
            console.debug('VisualSimilarity: process started', message)
        }
    }

    handleProcessDone = (message: SimilarityWebSocketMessage) => {
        const data = this.getData()
        const hashList = data && data.data ? data.data.map(d => d.image_hash) : []

        if (message.project_id === projectId && hashList.includes(message.image_hash)) {
            console.debug('VisualSimilarity: process finished', message)
            this.props.updateProductsBouncedFast()
        }
    }

    showModal = (idx: number, altLevel?: number, editMode?: boolean) => {
        const { viewTable, project, alternativeTemplatesLevels } = this.props
        const { viewMode, imgMode } = this.state

        const userId = project.user && project.user.id ? project.user.id : null
        const data = this.getData()
        const d = data.data[idx] || null

        modal({
            overlayClassName: `${viewTable}-modal all-viewtables-modal`,
            style: { maxWidth: '95vw', maxHeight: '98vh' },
            hideCloseButton: viewTable === 'watermarks' && imgMode !== 'fie',
            message: (close) => <Provider store={store}>
                <ProductModalWrapper
                    alternativeTemplatesLevels={alternativeTemplatesLevels.data}
                    viewTable={viewTable}
                    imgMode={imgMode}
                    changeSetByUser={this.changeSetByUser}
                    data={d}
                    idx={idx}
                    altLevel={altLevel}
                    editMode={editMode}
                    isTheLast={data.page === data.max_page && data.data && idx === data.data.length}
                    isTheFirst={data.page === 1 && idx < 1}
                    updateWatermarkMasksFromDb={this.props.updateWatermarkMasksFromDb}
                    closeModal={close}
                    updateModal={(inc) => {
                        close()
                        if (inc === 1) {
                            this.nextProduct()
                        } else if (inc === -1) {
                            this.prevProduct()
                        }
                    }}
                    userId={userId}
                />
            </Provider>,
        })
    }

    createProductsExport = () => {
        this.props.createProductsExport({ ...this.props.filtersForm }, this.props.viewTable)
    }

    sectionPrefix = () => {
        return <StyledPrefixGrid>
            <Button
                id={'submit-button'}
                style={{
                    opacity: this.props.isDirty ? 1 : .5,
                    height: '100%',
                    alignItems: 'center',
                    color: 'white',
                    backgroundColor: Theme.blue,
                    webkitTransition: 'opacity 1s ease-in-out',
                    transition: 'opacity 1s ease-in-out',
                }}
                className={'v-align'}
                type={'void'}
                size={'small'}
                color={Theme.steelblue}
                onClick={(e) => this.props.filterNow()}>
                {trans('filter')}
            </Button>
            <Button
                type={'void'}
                size={'small'}
                color={Theme.red}
                className={'v-align'}
                onClick={(e) => this.props.resetFiltersButton()}>
                {trans('filter_remove')}
            </Button>
            {!(this.props.findSimilar && this.props.findSimilar.similarProducts && (Object.keys(this.props.findSimilar.similarProducts).length > 0 || this.props.findSimilar.isSearching)) &&
                <Button
                    type={'void'}
                    size={'small'}
                    color={Theme.orange}
                    disabled={this.props.findSimilar && this.props.findSimilar.similarProducts && Object.keys(this.props.findSimilar.similarProducts).length > 0}
                    className={'v-align'}
                    onClick={(e) => this.props.saveAsQuery()}>
                    {trans('save_as_query')}
                </Button>
            }
            <Button
                type={'void'}
                size={'small'}
                color={'nocolor'}
                className={`v-align ${this.props.filtersMode ? '' : 'rotated'}`}
                title={trans('view_mode')}
                onClick={(e) => this.props.switchFiltersMode()}
                icon={<Icon type={'layout-left-light'} color={Theme.blue} size={32} />}
            />
        </StyledPrefixGrid>
    }

    sectionSuffix = () => {
        const { filtersForm, isDirty } = this.props
        const productsData = this.getData()
        if (!productsData || !productsData.total_count) {
            return <span />
        }

        const groupCount = (!isDirty && productsData.total_count) ? ' (' + productsData.total_count + ')' : ''
        const showGroupList = filtersForm.image && filtersForm.image.showGroup ? filtersForm.image.showGroup : []

        const exportInfo = Array.isArray(showGroupList) ? showGroupList.map((showGroup: ShowGroupType) => {
            return trans('status_' + showGroup)
        }).join(',') + ' ' + groupCount.toString() : ''

        return <Button
            type={'void'}
            size="small"
            style={{ margin: "-10px 0" }}
            onClick={(e) => this.createProductsExport()}>
            {trans("export_to_csv")}
            <br />
            {exportInfo}
        </Button>
    }

    getData = (): ProductGeneral => {
        const { products } = this.props
        return products && products.data && products.data.products ? products.data.products : null
    }

    nextProduct = () => {
        const data = this.getData()
        const productsPerPage = data.data.length
        const newIndex = (this.state.idx + 1) % productsPerPage
        if (newIndex === 0) {   //next page
            if (data.page < data.max_page) {
                this.props.handlePaginator(data.page + 1)
            } else {
                return
            }
        }
        this.setState({ idx: newIndex })
        this.showModal(newIndex, null)
    }

    prevProduct = () => {
        const data = this.getData()
        const { filtersForm } = this.props
        const { productsPerPage } = filtersForm
        const newIndex = (this.state.idx - 1)
        if (newIndex < 0) {   //prev page
            if (data.page > 1) {
                this.props.handlePaginator(data.page - 1)
            } else {
                return
            }
        }

        const updatedIndex = newIndex >= 0 ? newIndex : (productsPerPage - 1)

        this.showModal(updatedIndex, null)
        this.setState({ idx: updatedIndex })
    }

    setValidationMistakeByUser = (imageId: ID, value: SetByUser) => {
        apiSetMistakeByUser(imageId, value)
            .then((response: any) => {
                console.debug(trans('mistake_by_user_successfully_changed'))
            }).catch(error => {
                console.error(trans('option_not_set'), error)
            })
    }

    setWatermarksMistakeByUser = (imageId: ID, value: SetByUser) => {
        apiSetWatermarksByUser(imageId, value)
            .then((response: AxiosResponse<any>) => {
                console.debug(trans('mistake_by_user_successfully_changed'))
            }).catch(error => {
                console.error(trans('option_not_set'), error)
            })
    }

    setQualityMistakeByUser = (imageId: ID, value: SetByUser) => {
        apiSetQualityByUser(imageId, value)
            .then((response: any) => {
                this.props.createToast(toastFactory(SET_QUALITY_BY_USER.SUCCESS))
            }).catch(error => {
                this.props.createToast(toastFactory(SET_QUALITY_BY_USER.ERROR, error))
            })
    }

    changeSetByUser = (imageId: ID, idx: number, value: SetByUser) => {
        let updatedProductsData = { ...this.props.products.data }
        switch (this.props.viewTable) {
            case "validations":
                this.setValidationMistakeByUser(imageId, value)
                updatedProductsData.products.data[idx].validations_mistake_set_by_user = value
                this.nextProduct()
                break
            case "images_quality":
                this.setQualityMistakeByUser(imageId, value)
                updatedProductsData.products.data[idx].quality_user_set = value
                this.nextProduct()
                break
            case "watermarks":
                this.setWatermarksMistakeByUser(imageId, value)
                updatedProductsData.products.data[idx].watermarks_user_set = value
                break
        }

        this.props.setProductsToStore(updatedProductsData)
    }

    getCheckedIds = (): ID[] => {
        //const checkboxes: HTMLCollectionOf<Element> = document.getElementsByClassName('m-bulk-action-item')
        const checkboxes: any = document.getElementsByClassName('m-bulk-action-item')
        let ids = []
        for (const item of checkboxes) {
            const itemId = item.getAttribute("data-id")
            if (item.checked && itemId) {
                ids.push(parseInt(item.getAttribute("data-id").replace('product-', '')))
            }
        }
        return ids
    }

    publishSelected = (type: 'downloader' | 'bgremover' | 'composer') => {
        const ids = this.getCheckedIds()

        publishProducts(ids, type)
            .then(response => {
                console.log(`published to ${type}`, response.data)
            })
            .catch(e => {
                console.error('something went wrong', e)
            })
    }

    nextImgMode = () => {
        const { imgMode, viewMode } = this.state

        if (viewMode === 'grid') {
            const currentModeIndex = imgModes.indexOf(imgMode)
            const nextIndex = viewMode === 'grid' ? (currentModeIndex + 1) % (imgModes.length) : imgMode
            if (imgMode === imgModes[imgModes.length - 1]) {
                this.setState({ imgMode: imgModes[0], viewMode: 'table' })
            } else {
                this.setState({ imgMode: imgModes[nextIndex] })
            }
        } else {
            this.setState({ viewMode: 'grid', imgMode: imgModes[0] })
        }
    }

    sectionHeader = (paginator: JSX.Element) => {
        const { viewMode, imgMode } = this.state

        return <StyledHeaderGrid cols={'max-content auto max-content'}>
            <GridCell style={{ selfAlign: 'center', textAlign: 'center', display: 'inline-flex', whiteSpace: 'nowrap' }}>
                <Checkbox
                    name={'filtersForm.groupByImage'}
                    label={trans("group_by_image")}
                    onChange={() => {
                        this.props.change('filtersForm', 'groupByImage', !this.props.filtersForm.groupByImage)
                        this.props.handlePaginator(1)
                        this.props.updateProductsBouncedFast()
                    }}
                />

                <Grid cols={'max-content max-content'} gap={'10px'} style={{ marginLeft: '20px' }}>
                    <TextInput
                        type='number'
                        className={'products-per-page'}
                        value={this.props.filtersForm.productsPerPage}
                        min={1}
                        max={MaxProductsPerPage}
                        name={'filtersForm.productsPerPage'}
                    />
                    <GridCell>{trans('products_per_page_on_list')}</GridCell>
                </Grid>
            </GridCell>

            <GridCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{paginator}</GridCell>
            <GridCell className={'hide-buttons'}>
                <InputGroup
                    orientation="horizontal"
                    singleChoice={true}
                    value={`${viewMode}_${imgMode}`}
                    style={{
                        " .m-item": {
                            padding: "5px !important",
                        },
                    }}
                    onChange={(e) => {
                        const values = e.split('_')
                        const imgMode = values[1]
                        this.setState({ viewMode: values[0], imgMode: imgMode })
                    }}
                    items={[
                        { value: 'table_orig', label: 'table_orig', text: <Icon type={'list'} color={Theme.steelblue} size={26} /> },
                        { value: 'grid_orig', label: 'grid_orig', text: <Badge badgeContent={<Icon type="image" color={'#ffffff'} />} color="primary"><Icon type={'th'} color={Theme.steelblue} size={26} /></Badge> },
                        { value: 'grid_fie', label: 'grid_fie', text: <Badge badgeContent={<Icon type="feedimageeditor" />} color="primary"><Icon type={'th'} color={Theme.steelblue} size={26} /></Badge> },
                        { value: 'grid_other', label: 'grid_other', text: <Badge badgeContent={<Icon type="caret-right" color={'#ffffff'} />} color="primary"><Icon type={'th'} color={Theme.steelblue} size={26} /></Badge> },
                    ]}
                />
            </GridCell>
        </StyledHeaderGrid>
    }

    render() {
        const { viewTable, products } = this.props
        const { viewMode, imgMode } = this.state

        const isLoading = (viewTable === 'products' && products.isLoading)
        const data = this.getData()

        const paginator = data && data.max_page && data.max_page > 1 ?
            <Paginator
                showFirstAndLast={true}
                showPrevAndNext={true}
                maxLinks={3}
                style={{ display: 'inline-flex' }}
                currentPage={data.page} lastPage={data.max_page}
                onPageChange={(e) => this.props.handlePaginator(e)}
            /> : <span />

        return <StyledProductsSection
            prefix={viewTable !== 'fie_queries' ? this.sectionPrefix() : ''}
            header={this.sectionHeader(paginator)}
            suffix={this.sectionSuffix()}
            className={isLoading ? 'reload-needed' : ''}
            id={'products-section'}
        >
            {data && data.total_count === 0 &&
                <div>
                    {viewTable === 'products' && products.data.is_new &&
                        <Message type="warning" closeable={true} icon={<Icon type={'info'} color={Theme.blue} size={20} />} timeout={50000}>
                            {trans('info_is_new')}
                        </Message>
                    }

                    <Message type="info" closeable={true} icon={<Icon type={'info'} color={Theme.blue} size={20} />}>
                        {trans('info_no_data')} {trans('info_not_processed_yet')}
                    </Message>
                </div>
            }

            {data && data.total_count > 0 && viewMode === 'table' &&
                <ProductTableTable
                    data={data}
                    isLoading={isLoading}
                    paginator={paginator}
                    handleSortBy={this.props.handleSortBy}
                    publishSelected={this.publishSelected}
                    viewTable={viewTable}
                    changeSetByUser={this.changeSetByUser}
                    showModal={this.showModal}
                    getEmptyFiltersForm={this.props.getEmptyFiltersForm}
                    updateWatermarkMasksFromDb={this.props.updateWatermarkMasksFromDb}
                />
            }

            {data && data.total_count > 0 && viewMode === 'grid' &&
                <ProductTableGrid
                    data={data}
                    isLoading={isLoading}
                    paginator={paginator}
                    handleSortBy={this.props.handleSortBy}
                    publishSelected={this.publishSelected}
                    viewTable={viewTable}
                    changeSetByUser={this.changeSetByUser}
                    showModal={this.showModal}
                    getEmptyFiltersForm={this.props.getEmptyFiltersForm}
                    updateWatermarkMasksFromDb={this.props.updateWatermarkMasksFromDb}
                    imgMode={imgMode}
                />
            }
        </StyledProductsSection>
    }
}

export const StyledProductsSection = css(Section)({
    ' .muk-gridcell': {
        alignSelf: 'center',
    },
    ' > .m-header': {
        textAlign: 'center',
        overflowY: 'hidden',
        '@media screen and (max-width: 800px)': {
            gridTemplateColumns: 'auto',
        },
    },
    '@media screen and (max-width: 1024px)': {
        ' > div.m-content': {
            padding: 0,
        },
        ' .m-suffix': {
            visibility: 'visible',
            display: 'block',
        }
    },
    ' .m-button-void': {
        display: 'grid !important'
    }
})


export const ImagePreviewWrapper = css('div')({
    textAlign: 'center',
    color: 'rgb(102, 102, 102)',
    fontSize: '1.2em',
    width: "100%",
    padding: 0,
    "img": {
        maxWidth: "100%",
        maxHeight: 'calc(100vh - 250px)'
    },
    ' .m-image': {
        overflowY: 'hidden',
    },
    ' .prev-link, .next-link': {
        textAlign: 'center',
        alignSelf: 'center',
        ' .muk-button': {
            padding: 0,
            border: 0,
        }
    },
})

const StyledHeaderGrid = css(Grid)({
    gridColumnGap: '10px',
    ' .muk-button': {
        padding: '15px',
        alignSelf: 'center',
    },
    '@media screen and (max-width: 1400px)': {
        gridTemplateColumns: 'auto auto',
    },
    '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: 'auto max-content',
    },
    '@media screen and (max-width: 800px)': {
        gridTemplateColumns: 'auto',
    },
    ' .muk-gridcell': {
        alignSelf: 'center',
    },
    'input': {
        maxWidth: '100px',
    },
    ' .label': {
        textAlign: 'right',
        paddingRight: '20px',
    },
    ' .muk-form-group': {
        marginBottom: '0 !important',
    },
    ' .products-per-page input': {
        paddingRight: '0 !important',
    },
})

const StyledList = css("div")({
    position: 'relative',
    display: 'inline-block',
    ' .dropbtn': {
        padding: '10px',
        cursor: 'hand',
    },
    ' .dropdown-content': {
        display: 'none',
        position: 'absolute',
        overflow: 'hidden',
        backgroundColor: '#f1f1f1',
        minWidth: 'auto',
        whiteSpace: 'nowrap',
        boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
        padding: '0 15px',
        zIndex: 1,
        maxHeight: '150px',
        overflowY: 'auto',
    },
    ' .list-item': {
        color: 'black',
        padding: '5px 16px',
        textDecoration: 'none',
        display: 'block',
        ':hover': {
            backgroundColor: '#ddd',
        },
    },
    ':hover': {
        ' .dropdown-content': {
            display: 'block',
        },
        ' .dropbtn': {
            backgroundColor: '#f1f1f1',
        },
    },
    ' .count': {
        color: Theme.blue,
        fontSize: 'smaller',
    }
})

export function renderName(name) {
    const names = name && isJson(name) ? JSON.parse(name) : null
    const first = name && Array.isArray(names) && names[0].name ? names[0].name : name

    const nameFormatted = names && Array.isArray(names) ? names.map((o: any, idx: any) => {
        return <div key={idx} className={'list-item'}>{o.name}</div>
    }) : <div />

    return <>
        {Array.isArray(names) && names.length > 1 ?
            <StyledList>
                <span className="dropbtn">{first}<span className={'count'}>&nbsp;({names.length})</span></span>
                <div className="dropdown-content">
                    {nameFormatted}
                </div>
            </StyledList>
            :
            <span>{first}</span>
        }
    </>
}

export function renderItemId(item_id) {
    const item_ids = item_id ? isJson(item_id) && JSON.parse(item_id) : null
    const firstItemId = item_ids && Array.isArray(item_ids) && item_ids[0].item_id ? item_ids[0].item_id : item_id

    const itemIdFormatted = item_ids ? Array.isArray(item_ids) && item_ids.map((o: any, idx: any) => {
        return <span className={'productItemAndNo'} key={idx}>
            <Icon type={'tag'} className="item-id" size={12} text={o.item_id} title={"ITEM_ID"} />
        </span>
    }) : <span />


    return <>
        {Array.isArray(item_ids) && item_ids.length > 1 ?
            <StyledList>
                <span className="dropbtn"><Icon type={'tag'} className="item-id" size={12} text={firstItemId} title={"ITEM_ID"} /> <span className={'count'}>({item_ids.length})</span></span>
                <div className="dropdown-content">
                    {itemIdFormatted}
                </div>
            </StyledList>
            :
            <Icon type={'tag'} className="item-id" size={12} text={firstItemId} title={"ITEM_ID"} />
        }
    </>
}

export const availableValidationOptionsMistakeByUser: Option[] = [
    { value: '0', label: trans('status_NOT_OK'), text: <Icon type={'cross-2-radix'} text={trans('status_NOT_OK')} color={Theme.red} /> },
    { value: '1', label: trans('status_OK'), text: <Icon type={'check'} text={trans('status_OK')} color={ Theme.green} /> },
]

export const availableQualityOptionsMistakeByUser: Option[] = [
    { value: '0', label: trans('status_NOT_OK'), text: <Icon type={'cross-2-radix'} text={trans('status_NOT_OK')} color={Theme.red} /> },
    { value: '1', label: trans('status_OK'), text: <Icon type={'check'} text={trans('status_OK')} color={ Theme.green} /> },
]

export const availableWatermarksOptionsMistakeByUser: Option[] = [
    { value: '0', label: trans('has_no_watermark'), text: <Icon type={'cross-2-radix'} text={trans('has_no_watermark')} color={Theme.green} /> },
    { value: '1', label: trans('has_watermark'), text: <Icon type={'paw'} text={trans('has_watermark')} color={Theme.green} /> },
]

const StyledPrefixGrid = css(Grid)({
    gridGap: '3px',
    gridAutoFlow: 'column',
    ' button': {
        display: 'none',
    },
    ' .rotated .m-image': {
        transform: 'rotate(-90deg)',
        transitionDuration: '.8s',
    },
    ' .v-align': {
        alignContent: 'center',
        height: '100%',
    }
})

function mapStateToProps(state) {
    return {
        project: state.project.data,
        alternativeTemplatesLevels: state.alternativeTemplatesLevels,
        filtersForm: selectFormValues(state, 'filtersForm'),
        findSimilar: state.findSimilar,
        products: state.products,
        validations: state.validations,
        watermarks: state.watermarks,
        imageQuality: state.imageQuality,
    }
}

export default connect(mapStateToProps, {
    setFindSimilar,
    setProductsToStore,
    createProductsExport,
    createToast,
    change,
})(ProductTable)

